import { environment } from '@quartz-iam-legacy/environments/environment';

export class NewIamHelper {
    static #getEmployeeSegment() {
        return '/Employee';
    }

    static getEmployeeFullPath() {
        return `${environment.iamUrl}${this.#getEmployeeSegment()}`;
    }

    static #getEmployeeDetailsSegment(employeeId) {
        return `${this.#getEmployeeSegment()}/${employeeId}`;
    }

    static getEmployeeDetailsFullPath(employeeId) {
        return `${environment.iamUrl}${this.#getEmployeeDetailsSegment(employeeId)}`;
    }

    static #getControlCenterSegment() {
        return '/Search/ControlCenter';
    }

    static getControlCenterFullPath() {
        return `${environment.iamUrl}${this.#getControlCenterSegment()}`;
    }

    static getFullPath(state, param) {
        switch (state) {
            case ('profile.employee'): {
                if (param) {
                    return this.getEmployeeDetailsFullPath(param);
                }
                return this.getEmployeeFullPath();
            }

            case ('event'): {
                return this.getControlCenterFullPath();
            }

            default:
                break;
        }
        return null;
    }

    static navigateTo(state, param) {
        const path = this.getFullPath(state, param);
        if (!path) {
            return;
        }
        window.location = path;
    }
}
